<template>
  <div class="login">
    <div class="login-con">
<!--      <Card icon="log-in" :title="type == 2? '立即注册': type == 3 ||  type == 4? '密码找回': '欢迎登录'" :bordered="false">-->
      <Card icon="log-in" :bordered="false">
        <div class="form-con" v-if="type != 4">
          <Form ref="formInline" :model="formInline" :rules="ruleInline" inline v-if="type ==1 || type == 2">
            <FormItem prop="user" style="width: 100%;">
              <Input type="text" prefix="ios-person-outline" v-model="formInline.user" placeholder="邮箱"/>
            </FormItem>
            <FormItem prop="password" style="width: 100%;">
              <Input type="password" prefix="ios-lock-outline" v-model="formInline.password" placeholder="密码" />
            </FormItem>
            <FormItem prop="code" style="width: 100%;" v-if="type== 2">
              <Row>
                <Col span="14">
                  <Input type="text" prefix="ios-lock-outline" v-model="formInline.code" placeholder="验证码" />
                </Col>
                <Col span="8" offset="1">
                  <Button type="primary"  v-if="sendTime <= 0" @click="sendCode" style="width: 90px">发送验证</Button>
                  <Button type="primary"  v-if="sendTime > 0" disabled style="width: 90px">{{sendTime}}</Button>
                </Col>
              </Row>
            </FormItem>
            <FormItem style="width: 100%;">
              <Button type="primary" @click="handleSubmit('formInline')" v-if="type == 1" long>登录</Button>
              <Button type="primary" @click="handleSubmit('formInline')" v-if="type == 2" long>注册</Button>
            </FormItem>
          </Form>
          <!-- 找回密码 -->
          <Form ref="formInline" :model="formInline" :rules="ruleInline" inline v-if="type == 3">
            <FormItem prop="user" style="width: 100%;">
              <Input type="text" prefix="ios-person-outline" v-model="formInline.user" placeholder="邮箱"/>
            </FormItem>
            <FormItem prop="code" style="width: 100%;" >
              <Row>
                <Col span="14">
                  <Input type="text" prefix="md-code" v-model="formInline.reCode" placeholder="验证码" />
                </Col>
                <Col span="8" offset="1">
                  <Button type="primary"  v-if="sendTime <= 0" @click="sendCode" style="width: 90px">发送验证</Button>
                  <Button type="primary"  v-if="sendTime > 0" disabled style="width: 90px">{{sendTime}}</Button>
                </Col>
              </Row>
            </FormItem>
            <FormItem prop="password" style="width: 100%;" v-if="formInline.reCode.length >= 4">
              <Input type="password" prefix="ios-lock-outline" v-model="formInline.password2" placeholder="重置密码" />
            </FormItem>
            <FormItem style="width: 100%;">
              <Button type="primary" @click="handleSubmit('formInline')" v-if="type == 1" long>登录</Button>
              <Button type="primary" @click="handleSubmit('formInline')" v-if="type == 2" long>注册</Button>
              <Button type="primary" @click="resetPassword()" v-if="type == 3" long>重置密码</Button>
            </FormItem>
          </Form>
<!--          <p class="login-tip" @click="type = 2" v-if="type == 1">没有账号，立即注册</p>-->
<!--          <p class="login-tip" @click="type = 1" v-if="type == 2">已有账号，马上登录</p>-->
          <p class="login-tip" @click="switchType(3)" v-if="type == 1">忘记密码？</p>
          <p class="login-tip" @click="type = 1" v-if="type == 3">马上登录</p>
        </div>
        <div class="form-con" v-if="type == 4">
          <div style="text-align: center; height: 200px; padding-top: 50px">
            密码重置成功
            <div style="cursor: pointer; color: #2d8cf0; margin-top: 10px;" @click="type = 1">返回登录</div>
          </div>
        </div>
      </Card>
    </div>
    <Spin fix size="large" v-if="loadingShow">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading...</div>
    </Spin>
  </div>
</template>

<script>
import Core from '@/until/core'
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      loadingShow: false,
      intervalId: null,
      sendTime: 0,
      type: 1,
      formInline: {
        user: '',
        password: '',
        password2: '',
        code: '',
        reCode: ''
      },
      ruleInline: {
        user: [
          { required: true, message: '请填写邮箱', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请填写密码', trigger: 'blur' },
          { type: 'string', min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
        ],
        code: [
          { required: false, message: '请填写验证码', trigger: 'blur' }
        ]
      }
    }
  },
  components: {
  },
  methods: {
    ...mapActions([
      'getUserInfo'
    ]),
    resetPassword () {
      if (!this.formInline.user) {
        return this.$Message.error('邮箱不能为空！')
      }
      if (!this.formInline.reCode) {
        return this.$Message.error('验证码不能为空！')
      }
      if (this.formInline.reCode.length < 4) {
        return this.$Message.error('验证码有误！')
      }
      if (!this.formInline.password2) {
        return this.$Message.error('重置密码不能为空！')
      }
      const param = {
        email: this.formInline.user,
        password: this.formInline.password2,
        confirm_password: this.formInline.password2,
        code: this.formInline.reCode
      }
      Core('/Auction/User/Chang', {database: param}).then(res => {
        if (res.error_code) {
          return this.$Message.error(res.error_msg || '系统繁忙！')
        }
        this.$Message.success(res.data || '密码修改成功！')
        this.type = 4
        this.formInline.reCode = ''
        this.formInline.password2 = ''
      })
    },
    switchType (type) {
      this.type = type
      if (type === 3) {
        this.formInline.reCode = ''
        this.formInline.password2 = ''
      }
    },
    sendCode () {
      if (!this.formInline.user) {
        return this.$Message.error('邮箱不能为空！')
      }
      let v = /^([a-z0-9_.-]+)@([\da-z.-]+)\.([a-z.]{2,6})$/
      if (!v.test(this.formInline.user)) {
        return this.$Message.error('请输入正确的邮箱！')
      }
      let url = ''
      if (this.type === 2) {
        url = '/Auction/User/send'
      } else if (this.type === 3) {
        url = '/Auction/User/sendcode'
      } else {
        return
      }
      this.loadingShow = true
      Core(url, {email: this.formInline.user}).then(body => {
        this.loadingShow = false
        if (body.error_code) {
          return this.$Message.error(body.error_msg || '验证码发送失败！')
        }
        this.$Message.success('验证码发送成功，请注意查收！')
        this.sendTime = 60
        this.intervalId = setInterval(() => {
          if (this.sendTime > 0) {
            this.sendTime--
          } else {
            if (this.intervalId) { clearInterval(this.intervalId) }
          }
        }, 1000)
      }).finally(() => {
        this.loadingShow = false
      })
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$Loading.start()
          const param = {
            email: this.formInline.user,
            password: this.formInline.password
          }
          let url = '/Auction/User/Login'
          if (this.type === 2) {
            if (!this.formInline.code) { return this.$Message.error('请填写验证码！') }
            url = '/Auction/User/Creates'
            param.code = this.formInline.code
          }
          Core(url, param).then(body => {
            this.$Loading.finish()
            if (body.error_code) {
              return this.$Message.error(body.error_msg || '系统繁忙，请稍后再试！')
            }
            if (this.type === 1) {
              localStorage.setItem('access_code', body.data.access_code)
              Core.setCookie(body.data.access_token, body.data.expires_time)
              this.getUserInfo()
              this.$router.push({
                name: 'Home'
              })
            } else if (this.type === 2) {
              this.$Message.success('注册成功！')
              setTimeout(() => {
                this.type = 1
                this.handleSubmit('formInline')
              }, 2000)
            }
          })
        }
      })
    }
    // handleSubmit ({ userName, password }) {
    //   if (!userName || !password) {
    //     this.ruleInline.user.required
    //     return
    //   }
    //   this.$Loading.start()
    //   // this.$router.push({
    //   //   name: 'Home'
    //   // })
    //   // this.handleLogin({ userName, password }).then(res => {
    //   //   this.getUserInfo().then(res => {
    //   //     this.$router.push({
    //   //       name: this.$config.homeName
    //   //     })
    //   //   })
    //   // })
    // }
  }
}
</script>

<style>
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }

  .login{
    width: 100%;
    height: 100%;
    background-image: url('../assets/images/login-bg2.jpg');
    background-size: cover;
    background-position: center;
    position: relative;
  }
  .login-con{
    position: absolute;
    left: 50%;
    margin-left: -150px;
    top: 50%;
    transform: translateY(-60%);
    width: 300px;
  }
  .login-con .ivu-card{ background: url("../assets/images/login-form.jpg");padding-top: 40px;}
  .login-con-header{
    font-size: 16px;
    font-weight: 300;
    text-align: center;
    padding: 30px 0;
  }
  .form-con{
    padding: 10px 0 0;
  }
  .login-tip{
    font-size: 10px;
    text-align: center;
    color: #342d2d;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue